import { useCallback } from 'react';
import type { JSX } from 'react';

import { Loader } from '@change-corgi/design-system/components/progressiveDisclosure';
import { Box } from '@change-corgi/design-system/layout';

import { LazyComponent } from 'src/app/shared/components/layout/lazy';

import type { AIAsksChoiceStep } from './AIAsksChoice';

async function LoadAIAsksChoiceStep(): Promise<typeof AIAsksChoiceStep> {
	return (await import(/* webpackChunkName: "pages/start-a-petition-steps-ai-asks-choice" */ './AIAsksChoice'))
		.AIAsksChoiceStep;
}

export function AIAsksChoiceLoader(): JSX.Element {
	const loadComponent = useCallback(LoadAIAsksChoiceStep, []);

	return (
		<LazyComponent
			loadComponent={loadComponent}
			fallback={
				<Box margin="auto">
					<Loader />
				</Box>
			}
		/>
	);
}

export const preloadAIAsksChoiceStep = LoadAIAsksChoiceStep;
